import Flex from "@/components/Flex";
import ToggleSettingList from "@/components/ToggleSettingList";
import {
  NOTIFICATION_CARD_WIDTH,
  NOTIFICATION_CHANNEL_ITEMS,
  NOTIFICATION_LABEL,
  NOTIFICATION_SECTION,
} from "../group-visit-constant";
import {
  GroupNotificationSettings,
  NotificationSection,
} from "../group-visit-types";
import DetailCard from "./DetailCard";

export type NotificationsRemindersTabProps = {
  settings: GroupNotificationSettings;
  onChange: (
    section: NotificationSection,
    id: string,
    checked: boolean
  ) => void;
  disabled?: boolean;
};

/**
 * @author Rajkumar Rathod
 */
const NotificationsRemindersTab = ({
  settings,
  onChange,
  disabled,
}: NotificationsRemindersTabProps) => {
  return (
    <Flex gap={2} flexWrap="wrap" alignItems="flex-start">
      <DetailCard
        title={NOTIFICATION_LABEL.channelsCard}
        sx={{ width: NOTIFICATION_CARD_WIDTH, maxWidth: "100%" }}
      >
        <ToggleSettingList
          items={NOTIFICATION_CHANNEL_ITEMS}
          values={settings.channels}
          disabled={disabled}
          onChange={(id, checked) =>
            onChange(NOTIFICATION_SECTION.CHANNELS, id, checked)
          }
        />
      </DetailCard>

      {/* Reminder schedule card removed from the tab; the settings still persist.
      <DetailCard
        title={NOTIFICATION_LABEL.reminderScheduleCard}
        sx={{ width: NOTIFICATION_CARD_WIDTH, maxWidth: "100%" }}
      >
        <ToggleSettingList
          items={REMINDER_SCHEDULE_ITEMS}
          values={settings.reminders}
          disabled={disabled}
          onChange={(id, checked) =>
            onChange(NOTIFICATION_SECTION.REMINDERS, id, checked)
          }
        />
      </DetailCard> */}
    </Flex>
  );
};

export default NotificationsRemindersTab;
